import heroImage from './assets/heroimage.jpg'
import heroImageMobile from './assets/heroimage-mobile.jpg'

import type { HeroFields } from './types'
import type { RichTextContent } from '../../types/contentstack'

const heroBody = {
  type: 'doc',
  uid: 'hero-body-doc',
  attrs: {},
  children: [
    {
      type: 'p',
      uid: 'hero-body-p1',
      attrs: {},
      children: [
        {
          text: "Looking for easy, delicious meals to make at home? Gousto's food box delivery service has you covered.",
        },
      ],
    },
    {
      type: 'p',
      uid: 'hero-body-p2',
      attrs: {},
      children: [
        {
          text: "With over 175 tasty recipes to choose from every week, there's something for everyone.",
        },
      ],
    },
  ],
} as unknown as RichTextContent

export const heroMockData: HeroFields = {
  heading: "Recipe Boxes from Gousto: The UK's best food box for choice",
  body: heroBody,
  cta: {
    text: "Explore this week's menu",
    url: '/menu',
    variant: 'primary',
  },
  image: {
    uid: 'hero-image',
    url: heroImage,
    title:
      'A range of Gousto recipes from our 10-minute meals, global cuisines and family classics, all packed with fresh ingredients.',
    filename: 'heroimage.jpg',
    content_type: 'image/jpeg',
  },
  image_mobile: {
    uid: 'hero-image-mobile',
    url: heroImageMobile,
    title:
      'A range of Gousto recipes from our 10-minute meals, global cuisines and family classics, all packed with fresh ingredients.',
    filename: 'heroimage-mobile.jpg',
    content_type: 'image/jpeg',
  },
  image_alt:
    'A range of Gousto recipes from our 10-minute meals, global cuisines and family classics, all packed with fresh ingredients.',
}
